import { REGISTER_ACTION_MESSAGES, RegisterActionMessages } from "./register-action-messages";
import { REGISTER_ERROR_MESSAGES, RegisterErrorMessages } from "./register-error-messages";
import { REGISTER_FORM_MESSAGES, RegisterFormMessages } from "./register-form-messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { RECAPTCHA_MESSAGES, RecaptchaMessages } from "../recaptcha/recaptcha.messages";

export type RegisterMessages = SidebarMessages &
  RecaptchaMessages &
  RegisterFormMessages &
  RegisterActionMessages &
  RegisterErrorMessages & {
    // Título e Mensagens de Boas-vindas
    registerTitle: string;
    registerDescription: string;
    registerPlanHighlight: string;
    welcomeMessage: string;
    enterDetailsMessage: string;
    changePasswordRequirements: string;

    // Password messages
    changePasswordRequirementsDescription: string;
    changePasswordSpecialCharacterRule: string;
    changePasswordMinRule: string;
    changePasswordOneNumberRule: string;
    changePasswordLowerRule: string;
    changePasswordUpperRule: string;

    ddiBrazilOption: string;

    logoAlt: string;
  };

export const REGISTER_MESSAGES: RegisterMessages = {
  // Título e Mensagens de Boas-vindas
  registerTitle: "Cadastre-se agora",
  registerDescription: "Insira seus dados para fazer o seu cadastro grátis e",
  registerPlanHighlight: "escolha seu plano.",
  welcomeMessage: "Seja bem-vindo(a)",
  enterDetailsMessage: "Insira seus dados abaixo.",
  changePasswordRequirements: "Requisitos de senha",

  // Password messages
  changePasswordRequirementsDescription: "Siga estes requisitos para ter uma senha forte",
  changePasswordSpecialCharacterRule: "Deve conter pelo menos 1 caractere especial",
  changePasswordMinRule: "Deve conter no mínimo 8 caracteres.",
  changePasswordOneNumberRule: "Deve conter pelo menos 1 caractere numérico",
  changePasswordLowerRule: "Deve conter pelo menos 1 caractere minúsculo",
  changePasswordUpperRule: "Deve conter pelo menos 1 caractere maiúsculo",

  ddiBrazilOption: "Brasil",

  logoAlt: "Talk2Buy logo",

  ...SIDEBAR_MESSAGES,
  ...RECAPTCHA_MESSAGES,
  ...REGISTER_FORM_MESSAGES,
  ...REGISTER_ACTION_MESSAGES,
  ...REGISTER_ERROR_MESSAGES,
};

export default REGISTER_MESSAGES;
